var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.7208 4.25316L3.72083 4.25314L3.71725 4.2488L1.47502 1.53202C1.40353 1.44186 1.35852 1.33355 1.34507 1.2192C1.3315 1.10382 1.3506 0.98695 1.40021 0.881913L1.40036 0.881985L1.40563 0.870036C1.43959 0.792967 1.49501 0.72732 1.56525 0.680925C1.63484 0.634965 1.71606 0.609818 1.79938 0.608398H6.28226C6.36558 0.609818 6.4468 0.634965 6.51639 0.680925C6.58663 0.727319 6.64205 0.792966 6.67601 0.870036L6.67586 0.870105L6.68143 0.881913C6.73104 0.986952 6.75014 1.10382 6.73657 1.2192C6.72312 1.33354 6.67812 1.44185 6.60663 1.53202L4.36439 4.2488L4.36437 4.24878L4.36084 4.25316C4.32195 4.30136 4.27283 4.3403 4.21704 4.36715C4.16202 4.39364 4.10186 4.40771 4.04082 4.40838C3.97978 4.40771 3.91962 4.39364 3.8646 4.36715C3.80881 4.3403 3.75969 4.30136 3.7208 4.25316Z",
    fill: "#1271A6",
    stroke: "#1271A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdown);
export default __webpack_public_path__ + "static/media/arrowdown.d2f40ed6b2795e137866a1d71922df5c.svg";
export { ForwardRef as ReactComponent };